import {clickEvent, mouseEnterEvent} from "../../../webpack/modules/events";
import {hideLoader, showLoader, showOffcanvasByDomObject} from "../../../webpack/modules-optimized/offcanvas";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

mouseEnterEvent('#product-page .open-product-reviews', false, function() {
    import(/* webpackChunkName: "product-page-reviews" */ './main');
});


clickEvent('#product-page .open-product-reviews', false, async function(element) {
    let ga4Event = element.dataset.event;
    let reference = element.dataset.productReference;
    let productId = element.dataset.productId;
    let offcanvas = document.getElementById('reviews-offcanvas');
    let button = offcanvas.querySelector('#load-more-product-reviews');

    showLoader(offcanvas);
    showOffcanvasByDomObject(offcanvas);
    await import(/* webpackChunkName: "product-page-reviews" */ './main');
    hideLoader(offcanvas);
    button.dataset.id = productId;
    button.dataset.page = 1;
    ga4TrackSimpleEvent({
        'event': ga4Event,
        'method': 'show_product_reviews',
        'content_type': reference
    });
});